const ITEMS = [
  "Copper 10% below LME",
  "MOQ 100 MT",
  "30% advance · 70% at port",
  "Shipping worldwide",
  "Coal in stock now",
  "World's cheapest coal",
  "Aluminium ingots",
  "Lusaka · Zambia",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-zinc-800 bg-surface py-5" data-testid="marquee">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display px-8 text-lg font-medium uppercase tracking-wide text-zinc-400">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-copper" />
          </span>
        ))}
      </div>
      <div className="hazard mt-5" aria-hidden="true" />
    </div>
  );
};
